import Checkout from "../features/Cart/Checkout";

function CheckoutPage() {

    return (
        <Checkout />
    );
}

export default CheckoutPage;